import _has from 'lodash/has';
import _set from 'lodash/set';

export default class BaseConvert {
    /**
     *
     * @param sdkData       用于转换使用的SDK 数据
     * @param uiData        转换到的目标的UImodel 数据
     * @param csData        changeset的可视化数据
     */
    public static convertDataSdkToUi(sdkData: any, uiData: any, csData: any) {
        if (_has(sdkData, 'id')) {
            _set(uiData, 'id', sdkData.id);
        }
        if (csData) {
            // eslint
        }
        if (_has(sdkData, 'name')) {
            _set(uiData, 'name', sdkData.name);
        }
    }

    /**
     *
     * @param uiData
     * @param sdkData
     * @param rawUiData
     */
    public static convertDataUiToSdk(uiData, sdkData, rawUiData) {
        if (rawUiData) {
            // eslint
        }
        if (_has(uiData, 'name')) {
            _set(sdkData, 'name', uiData.name);
        }
    }
}

